import React, { useEffect, useState } from 'react';
import { Trophy, Star, Flame, Crown, Sparkles } from 'lucide-react';

const MilestoneAnimation = ({ type, onComplete }) => {
  const [visible, setVisible] = useState(true);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Generate confetti particles
    const newParticles = [];
    for (let i = 0; i < 50; i++) {
      newParticles.push({
        id: i,
        x: Math.random() * 100,
        delay: Math.random() * 2,
        duration: 2 + Math.random() * 2,
        color: ['#face39', '#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7'][Math.floor(Math.random() * 6)]
      });
    }
    setParticles(newParticles);

    // Auto-hide after animation
    const timer = setTimeout(() => {
      setVisible(false);
      onComplete?.();
    }, 4000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  const milestoneConfig = {
    streak: {
      icon: Flame,
      title: "7-Day Streak!",
      subtitle: "You're on fire!",
      gradient: "from-orange-400 to-red-500",
      iconColor: "text-orange-500"
    },
    levelup: {
      icon: Crown,
      title: "Level Up!",
      subtitle: "Your brain is growing stronger!",
      gradient: "from-purple-400 to-pink-500",
      iconColor: "text-purple-500"
    },
    week: {
      icon: Trophy,
      title: "Week Complete!",
      subtitle: "Amazing progress!",
      gradient: "from-yellow-400 to-orange-500",
      iconColor: "text-yellow-500"
    },
    challenge: {
      icon: Star,
      title: "Challenge Complete!",
      subtitle: "You're a champion!",
      gradient: "from-blue-400 to-purple-500",
      iconColor: "text-blue-500"
    }
  };

  const config = milestoneConfig[type] || milestoneConfig.levelup;
  const Icon = config.icon;

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
      {/* Confetti */}
      <div className="absolute inset-0 overflow-hidden">
        {particles.map(particle => (
          <div
            key={particle.id}
            className="absolute w-3 h-3 rounded-full animate-confetti"
            style={{
              left: `${particle.x}%`,
              backgroundColor: particle.color,
              animationDelay: `${particle.delay}s`,
              animationDuration: `${particle.duration}s`
            }}
          />
        ))}
      </div>

      {/* Central celebration */}
      <div className="text-center animate-pop">
        <div className={`relative inline-flex items-center justify-center w-32 h-32 rounded-full bg-gradient-to-br ${config.gradient} shadow-2xl mb-6`}>
          <Icon className={`w-16 h-16 text-white animate-pulse`} />
          
          {/* Sparkles around icon */}
          <Sparkles className="absolute -top-2 -right-2 w-8 h-8 text-yellow-300 animate-spin-slow" />
          <Sparkles className="absolute -bottom-2 -left-2 w-6 h-6 text-yellow-300 animate-spin-slow" style={{ animationDirection: 'reverse' }} />
        </div>
        
        <h2 className="text-4xl font-black text-white drop-shadow-lg mb-2 animate-bounce-soft">
          {config.title}
        </h2>
        <p className="text-xl text-white/90 drop-shadow-md">
          {config.subtitle}
        </p>
      </div>
    </div>
  );
};

export default MilestoneAnimation;
